import React, { useState, useEffect } from "react";
import { Container, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import apiClient from "../../axiosInstance";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const OwnersList = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Owners List", link: "#" },
  ]);

  const [data, setData] = useState([]);
  const fetchOwners = async () => {
    try {
      const result = await apiClient.get("/owners/getAllOwners");
      const response = result.data.response;
      setData(response);
    } catch (err) {
      console.error("Error fetching owners:", err);
    }
  };

  useEffect(() => {
    fetchOwners();
  }, []);

  const handleDeleteOwner = async (ownerId) => {
    const confirmResult = await Swal.fire({
      title: "Delete Owner?",
      text: "Are you sure you want to delete this owner?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    try {
      const result = await apiClient.delete(`/owners/deleteOwner/${ownerId}`);

      if (result.data.status === "success") {
        setData((prevData) => prevData.filter((owner) => owner.id !== ownerId));
        await Swal.fire({
          title: "Deleted",
          text: result.data.message || "Owner deleted successfully",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      await Swal.fire({
        title: "Delete Failed",
        text: result.data.message || "Failed to delete owner",
        icon: "error",
      });
    } catch (err) {
      console.error("Error deleting owner:", err);
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to delete owner";
      await Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "full_name",
      header: "Full Name",
    },
    {
      accessorKey: "phone_number",
      header: "Phone",
    },
    {
      accessorKey: "branch_name",
      header: "Branch",
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Link
            to={`/owners/${row.original.id}`}
            className="btn btn-sm btn-primary"
          >
            <i className="ri-file-edit-line"></i>
          </Link>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => handleDeleteOwner(row.original.id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Users List" breadcrumbItems={breadcrumbItems} />
        <Card>
          <CardBody>
            <div className="row">
              <div className="col-12 text-end mb-2">
                <Link to="/createOwner">
                  <button className="btn btn-primary">Create Owner</button>
                </Link>
              </div>
            </div>
            <TanstackTable data={data} columns={columns} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default OwnersList;
